import { find, includes } from 'lodash-es'

import { useIsLoggedInUser, useUserHasPermissions } from '../../common/hooks'

import {
  BRAND_DEFINITION,
  BRAND_GATEWAY,
  DEFINE,
  DONE,
  MENU_DEFINITION,
  QC,
  QQA,
  RESOLVED,
} from '../constants'

const getRequiredPermission = (task, taskType, permissions) => {
  const definitionTasks = [BRAND_GATEWAY, BRAND_DEFINITION, MENU_DEFINITION]

  if (includes(definitionTasks, taskType)) {
    if (task.currentViewType === DEFINE) {
      return permissions.RESOLVE_DEFINE_VIEW
    }

    if (task.currentViewType === QC) {
      return permissions.RESOLVE_QC_VIEW
    }

    if (task.currentViewType === QQA) {
      return permissions.RESOLVE_QQA_VIEW
    }

    throw new Error('Invalid task view type')
  }

  return permissions.RESOLVE
}

const useCanUserResolveTask = (task, taskType, permissions) => {
  const isAssignedToUser = useIsLoggedInUser(task.assignedTo)
  const requiredPermission = getRequiredPermission(task, taskType, permissions)
  const hasPermission = useUserHasPermissions(requiredPermission)
  const hasAdminPermission = useUserHasPermissions(permissions.ADMIN)

  const hasPermissionToResolveTask = hasPermission || hasAdminPermission

  if (!task.currentViewType) {
    return (
      isAssignedToUser && hasPermissionToResolveTask && task.status !== RESOLVED
    )
  }

  const currentView = find(task.views, { type: task.currentViewType })

  return (
    isAssignedToUser &&
    hasPermissionToResolveTask &&
    currentView.status !== DONE
  )
}

export default useCanUserResolveTask
